export default "__VITE_ASSET__696eccb2__"